var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.transferLink}},[_vm._v("Xem chi tiết trái phiếu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }